import { useEffect } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import Grid from "@mui/material/Grid";

import constants from "../../../assets/constants";
import * as PatientSessionActions from "../../../state/redux/patientSession";
import Portal from "../../ui/portal";
import PortalAppBar from "../../ui/portalAppBar";
import PortalGridContent from "../../ui/portalGridContent";
import EmpireEmployees from "../../widgets/empireOS/empireEmployees";
import EmpireInformation from "../../widgets/empireOS/empireInformation";
import EmpireKPI from "../../widgets/empireOS/empireKPI";
import EmpireStoplight from "../../widgets/empireOS/empireStoplight";
import EmpireTodo from "../../widgets/empireOS/empireTodo";

const EmpirePatientPortal = props => {
  const { patientODM, loadPatientODMRequest } = props;

  useEffect(() => {
    if (patientODM == null) {
      loadPatientODMRequest(constants.demoUserId.userOne);
    }
  }, [patientODM, loadPatientODMRequest]);

  return (
    <Portal>
      <PortalAppBar title="Patient Portal" />
      <PortalGridContent>
        <Grid item sm={12} md={6}>
          <EmpireTodo />
        </Grid>
        <Grid item sm={12} md={6}>
          <EmpireKPI />
        </Grid>
        <Grid item sm={12} md={8}>
          <EmpireStoplight />
        </Grid>
        <Grid item sm={12} md={4}>
          <EmpireInformation />
        </Grid>
        <Grid item sm={12} md={12}>
          <EmpireEmployees />
        </Grid>
        <Grid item xs={12}></Grid>
      </PortalGridContent>
    </Portal>
  );
};

const mapStateToProps = state => ({
  patientODM: state.patientSession.patientODM,
  patientAssessments: state.patientSession.patientAssessments,
  bpShowChat: state.userSession.bpShowChat,
  awsGroup: state.userSession.awsGroup,

  //#region REFACTOR and DELETE
  patientChart: state.patientSession.patientChart,
  patientImage: state.patientSession.patientImage,
  //#endregion
});

const mapDispatchToProps = {
  loadPatientODMRequest: PatientSessionActions.loadPatientODMRequest,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(EmpirePatientPortal));
